//
//
//
//
//
//
//


export default {
  name: 'emptyCell',
  data() {
    return {}
  },
}
